export const usd = (v) => `$${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const pct = (v) => `${Number(v || 0).toFixed(Number(v) >= 10 || Number(v) === 0 ? 0 : 1)}%`;
export const valueLabel = (p) => (p?.value_type === "percent" ? `${p.value}% off` : usd(p?.value));
export const errMsg = (e, fb) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : d?.message || fb;
};
export const dateRange = (a, b) => {
  const s = (a || "").slice(0, 10), e = (b || "").slice(0, 10);
  if (s && e && s !== e) return `${s} → ${e}`;
  return s || e || "Dates TBD";
};
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
export const FORMATS = [
  ["business", 'Business card 3.5×2" — 10-up (Avery 5371)'],
  ["postcard", 'Postcard 6×4" — 2-up'],
  ["letter", 'Full page 8.5×11" flyer'],
];
export const THEMES = [["dark", "Brand dark"], ["light", "Ink-friendly light"]];
export const FUNNEL_STEPS = [
  ["live", "Issued"], ["scanned", "Scanned"], ["claimed", "Claimed"], ["reserved", "Reserved"], ["redeemed", "Redeemed"],
];
